import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import ConditionAggregator from '@piconetworks/condition-aggregator'
import Markdown from 'apps/containers/Prompt/Markdown'

import WizardRedux from 'common/pkgs/WizardRedux'
import Loader from 'common/modules/loader'
import OfferCode from 'common/components/OfferCode'

import { Form, FormSpy } from 'react-final-form'

const Offer = ({
    Selection,
    popupId,
    popup,
}) => {
    const paymentCustomTextUrl = useSelector((state) => (
        Loader.selectors.getPaymentPopupCustomTextFileNameById(state, popupId)))

    if (!Selection) {
        return null
    }

    const isDonation = (popup?.products || []).some((product) => product?.type.includes('donation'))

    return (
        <WizardRedux.Step
            onSubmit={({ values }) => {
                const productOptionId = values?.wizardData?.productOptionId
                const customPrice = values?.wizardData?.customPrice

                if (!productOptionId) {
                    throw new Error('Product not selected')
                }

                return {
                    optionId: productOptionId,
                    customPrice,
                }
            }}
            rffProps={{
                mutators: {
                    setWizardData: (args, state, utils) => {
                        utils.changeValue(state, 'wizardData', () => args[0])
                    },
                },
            }}
            render={({
                form,
            }) => (
                <>
                    {paymentCustomTextUrl && (
                        <Markdown url={paymentCustomTextUrl} />
                    )}
                    {!isDonation && <OfferCode />}
                    <ConditionAggregator
                        Submit={() => null}
                        onSubmit={async (e, data) => {
                            const preSubmitErrors = Object.values(data.preSubmitHookResults).find(
                                (preSubmitHookResult) => {
                                    const { error } = preSubmitHookResult || {}
                                    return !!error
                                },
                            )

                            if (preSubmitErrors?.error) {
                                throw new Error(preSubmitErrors.error)
                            }

                            const productOptionId = data.preSubmitHookResults?.plan?.productOptionId

                            const selectedOptionFieldName = `customPrice_${productOptionId}`
                            // eslint-disable-next-line max-len
                            const customPrice = data.preSubmitHookResults?.plan[selectedOptionFieldName]
                                || data.preSubmitHookResults?.plan?.customPrice

                            if (!productOptionId) {
                                throw new Error('Product not selected')
                            }

                            return {
                                productOptionId,
                                customPrice,
                            }
                        }}
                        postSubmit={(data) => {
                            // advance to the next wizard step
                            form.mutators.setWizardData(data.submitResults)

                            form.submit()
                        }}
                        conditions={{
                            plan: {
                                required: true,
                                isComplete: false,
                                preSubmit: async (data) => {
                                    const productOptionId = data?.state?.plan?.productOptionId
                                    const selectedOptionFieldName = `customPrice_${productOptionId}`
                                    const customPrice = data?.state?.plan[selectedOptionFieldName]
                                        || data?.state?.plan.customPrice

                                    if (!productOptionId) {
                                        throw new Error('Product not selected')
                                    }

                                    return {
                                        productOptionId,
                                        customPrice,
                                    }
                                },
                                Component: ({
                                    changeCompletionStatus, // eslint-disable-line react/prop-types
                                    // eslint-disable-next-line max-len
                                    submitConditionAggregator, // eslint-disable-line react/prop-types
                                    isComplete, // eslint-disable-line react/prop-types
                                }) => {
                                    if (isComplete) {
                                        submitConditionAggregator()

                                        return null
                                    }

                                    return (
                                        <Form
                                            mutators={{
                                                setProductOptionId: (args, state, utils) => {
                                                    // eslint-disable-next-line max-len
                                                    utils.changeValue(state, 'productOptionId', () => args[0])
                                                },
                                                setCustomPrice: (args, state, utils) => {
                                                    // eslint-disable-next-line max-len
                                                    utils.changeValue(state, 'customPrice', () => args[0])
                                                },
                                            }}
                                            onSubmit={() => { }}
                                            render={({ form: planForm }) => (
                                                <>
                                                    <FormSpy
                                                        onChange={(data) => {
                                                            if (
                                                                Object.keys(data?.errors).length
                                                            ) {
                                                                return
                                                            }

                                                            const hasSubmitValues = Object.keys(
                                                                data?.values,
                                                            ).length
                                                            const formIsValid = data.valid

                                                            const formIsComplete = !(
                                                                !hasSubmitValues || !formIsValid
                                                            ) && data?.values?.productOptionId

                                                            changeCompletionStatus({
                                                                isComplete: formIsComplete,
                                                                ...(formIsComplete && data?.values),
                                                            })
                                                        }}
                                                    />
                                                    <Selection
                                                        setProductOptionId={
                                                            planForm.mutators.setProductOptionId
                                                        }
                                                        setCustomPrice={
                                                            planForm.mutators.setCustomPrice
                                                        }
                                                    />
                                                </>
                                            )}
                                        />
                                    )
                                },
                            },
                        }}
                    />
                </>
            )}
        />
    )
}

export default Offer

Offer.defaultProps = {
    popupId: '',
    popup: {},
}

Offer.propTypes = {
    Selection: PropTypes.element.isRequired,
    popupId: PropTypes.string,
    popup: PropTypes.object,
}
